import React, { useState } from 'react';
import cx from 'classnames';

import { Small } from 'components/text';

import styles from './Input.module.scss';

import { InputProps } from './types';

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      placeholder,
      hasError,
      borders = ['t', 'r', 'b', 'l'],
      rounded = ['tl', 'tr', 'bl', 'br'],
      children,
      className,
      onFocus,
      ...props
    },
    ref
  ) => {
    const roundedClasses = rounded.map(edge => styles[`rounded-${edge}`]);
    const bordersClasses = borders.map(side => styles[`border-${side}`]);

    const [isFocused, setIsFocused] = useState(false);

    const containerClass = cx(
      styles.container,
      roundedClasses,
      bordersClasses,
      {
        [styles.error]: hasError,
        [styles.focused]: isFocused,
      },
      className
    );

    const handleFocus = () => {
      setIsFocused(true);
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      if (!!e.target.value) {
        return;
      }

      setIsFocused(false);
    };

    return (
      <div className={containerClass}>
        {children}
        <div>
          <input
            {...props}
            placeholder={isFocused ? placeholder : ''}
            onFocus={handleFocus}
            onBlur={handleBlur}
            ref={ref}
          />

          <Small
            className={styles.label}
            xs
            color="grey-dark"
            weight="demiBold"
          >
            {label}
          </Small>
        </div>
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
